import { updateItemInCollection } from "directus/src/operations";

export async function updateCategory({ item, categoryId }) {
  try {
    const data = await updateItemInCollection("survey_categories", categoryId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
